import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import PhraseInContextEditorPostProcessor from 'i18next-phrase-in-context-editor-post-processor';

import getConfig from '../config';

const { version } = getConfig();

const loadTranslations = (lang: string): Promise<{}> =>
  fetch(`/translations/${lang}/translation.json?${version}`)
    .then((resp: Response) => resp.json())
    .then((translation: {}) => ({ [lang]: { translation } }));

const getI18n = (lng: string): Promise<any> => {
  return loadTranslations(lng).then((resources: {}) =>
    i18n
      .use(initReactI18next)
      .use(
        new PhraseInContextEditorPostProcessor({
          phraseEnabled: false,
          projectId: '3188c7de7f97f0576f65cb83525c5c6d',
          prefix: '[[__',
          suffix: '__]]',
          fullReparse: true,
        })
      )
      .init({
        lng,
        resources,
        interpolation: { escapeValue: false },
        postProcess: ['phraseInContextEditor'],
      })
  );
};

export default getI18n;
